module.exports = __webpack_public_path__ + "img/tab_2.dbcf4eef.png";